module.exports = __webpack_public_path__ + "img/car_shina2_03.a58460e0.jpg";